<template>
  <div class="wrap relative">
    <template v-if="viewType === 1">
      <!-- 标题 -->
      <h1 class="common-header">{{ $t('1930') }}</h1>
      <!-- 内容 -->
      <div class="by-content">
        <div class="setting-month">
          <el-select v-model="settingForm.year" :placeholder="$t('405')" @change="getCycleList" class="margin-bottom">
            <el-option v-for="item in yearList" :key="item" :label="item" :value="item"> </el-option>
          </el-select>
          <!-- 考勤设置 -->
          <el-button class="right-box" @click="handlerView(2)" v-if="$p('menu.monthly-statistics.setting')">{{
            $t('449')
          }}</el-button>
          <!-- 表格数据 -->
          <el-table
            ref="table"
            :data="settingForm.tableData"
            v-load="settingForm.tableLoading"
            :loading-text="$t('989')"
          >
            <!-- 考勤月份 -->
            <el-table-column prop="name" :label="$t('1931')" align="center">
              <template slot-scope="{ row }">
                <span>{{ row.name }}</span>
                <el-tag size="mini" type="dark" v-if="row.this_month">{{ $t('1932') }}</el-tag>
              </template>
            </el-table-column>
            <!-- 考勤周期 -->
            <el-table-column :label="$t('wage.2')" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.begin }}</span>
                -
                <span>{{ scope.row.end }}</span>
              </template>
            </el-table-column>
            <el-table-column fixed="right" :label="$t('70')" align="center">
              <template slot-scope="scope">
                <!-- 查看 -->
                <el-button @click="handleClick(scope.row, scope.$index)" type="text" size="small">{{
                  $t('from_info')
                }}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </template>
    <Statistics v-if="viewType === 3" @close="handlerView" :cData="currentSelect" />
    <!-- 弹窗 -->
    <!-- 考勤设置 -->
    <AttendanceSettings v-if="viewType === 2" @close="handlerView" />
    <!-- 考勤周期设置 -->
    <AttendanceCycleSettings ref="attendanceSettings" @init="init" />
  </div>
</template>

<script>
import AttendanceCycleSettings from './modal/attendance-cycle-settings'
// 考勤设置
import AttendanceSettings from './modal/attendance-settings'
// 考勤月度统计
import Statistics from './modal/statistics'
// api
// 获取月度考勤周期列表
import { getCycleList } from 'api/Attendance/monthly-statistics'
import { yearList } from 'api/Attendance'

export default {
  components: {
    AttendanceCycleSettings,
    Statistics,
    AttendanceSettings
  },
  data() {
    return {
      yearList: [], // 可选年份
      viewType: 1, // 1 主页面 2 考勤设置 3 列表页
      currentSelect: {}, // 当前选中行
      settingForm: {
        tableLoading: false,
        year: '', // 搜索年份
        tableData: [] // 表格数据
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      // 获取年份选项
      yearList().then(res => {
        const { years, is_setting_cycle } = res.data
        this.yearList = years
        // 默认最后一年
        this.settingForm.year = years.slice(-1)[0]
        // 考勤周期设置
        // 当企业未设置考勤周期时，每次进入月度汇总页面时弹出“考勤周期设置”弹窗。
        if (!is_setting_cycle) this.$refs.attendanceSettings.visible = true
        if (this.settingForm.year) this.getCycleList()
      })
    },
    // 更改展示
    handlerView(viewType) {
      this.viewType = viewType
    },
    // 查看详情
    // row 表格当前行数据
    handleClick(row) {
      this.currentSelect = row
      // 去往详情
      this.handlerView(3)
    },
    // 获取月度考勤周期列表
    getCycleList() {
      this.settingForm.tableLoading = true
      getCycleList({ year: this.settingForm.year })
        .then(res => {
          // 表格数据
          const { date_range } = res.data
          this.settingForm.tableData = date_range
        })
        .finally(() => (this.settingForm.tableLoading = false))
    }
  }
}
</script>
